module.exports = __webpack_public_path__ + "img/deployment_1.68c82531.png";